import * as React from 'react'
import { cn } from '@/lib/utils'

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  animation?: 'border' | 'grow'
  size?: 'sm'
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
  as?: React.ElementType
}

const Spinner: React.FC<SpinnerProps> = ({
  animation = 'border',
  size,
  variant = 'primary',
  className,
  as: Component = 'div',
  ...props
}) => {
  return (
    <Component
      role="status"
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
        size === 'sm' ? 'h-4 w-4' : 'h-8 w-8',
        animation === 'grow' && 'animate-pulse',
        className,
      )}
      {...props}
    >
      <span className="sr-only">Loading...</span>
    </Component>
  )
}

export default Spinner
export { Spinner }
